import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { meSessionQueryOptions } from "@features/me/queries";
import { normalizePermission } from "@features/rbac/permissions";

export const Route = createFileRoute("/_layout/tools/teams-administration")({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(
			meSessionQueryOptions(),
		);
		const canManageTeams = session.permissions.some(
			(permission) => normalizePermission(permission) === "teams.manage",
		);
		if (session.viewMode !== "staff" || !canManageTeams) {
			throw redirect({ to: "/unauthorised" });
		}
	},
	component: RouteComponent,
	staticData: {
		crumb: {
			label: "Teams Administration",
		},
	},
});

function RouteComponent() {
	return <Outlet />;
}
